import styled from 'styled-components'
import { theme } from '../../../../../style/theme'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const BackInfoWrap = styled.div`
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-left: auto;

  &.double {
    .info {
      margin-left: 0.13em;
    }

    .back {
      margin-right: 0.13em
    }

    &.medium, &.x-medium, &.big {
      .info {
        margin-left: 0.25em;
      }

      .back {
        margin-right: 0.25em;
      }
    }

  }

  @media screen and (max-width: ${theme.point820}) {
    font-size: 0.71rem;
  }

  @media screen and (max-width: ${theme.point720}) {
    font-size: 1rem;

    &.double {

      &.x-medium {
        .info {
          margin-left: 0.15em;
        }

        .back {
          margin-right: 0.15em;
        }
      }
    }
  }
`
BackInfoWrap.displayName = 'BackInfoWrap'

export const SignButton = styled.button`
  font-size: 1em;
  width: 2em;
  height: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  background-color: ${colorTheme.cart.cartProduct.plusMinusButtons.minus.background};
  border: 1px solid ${colorTheme.cart.cartProduct.plusMinusButtons.minus.border};
  border-radius: 0.75em;
  cursor: pointer;
  box-sizing: border-box;

  > svg {
    width: 1em;
    height: 1em;
    fill: ${colorTheme.cart.cartProduct.plusMinusButtons.minus.icon};

    > path {
      width: 100%;
    }
  }

  // sizes:

  &.medium {
    width: 2.44em;
    height: 2.44em;
  }

  &.x-medium {
    width: 2.81em;
    height: 2.81em;

    > svg {
      width: 1.5em;
      height: 1.5em;
    }
  }

  @media screen and (max-width: ${theme.point820}) {
    border-radius: 1.01em;

    &.x-medium > svg {
      width: 1.4em;
      height: 1.4em;
    }

		&.medium {
		  font-size: 1rem;
			width: 2.79em;
			height: 2.79em;
		}
  }

  @media screen and (max-width: ${theme.point720}) {
    border-radius: 0.75em;

    &.x-medium {
      width: 2em;
      height: 2em;

      > svg {
        width: 0.94em;
        height: 0.94em;
      }
    }

		&.medium {
			width: 2.44em;
			height: 2.44em;
		}
  }
`

export const InfoButton = styled(SignButton)`
	background-color: ${colorTheme.cart.cartProduct.plusMinusButtons.plus.background};
	border: 1px solid ${colorTheme.cart.cartProduct.plusMinusButtons.plus.border};

	> svg {
		fill: ${colorTheme.cart.cartProduct.plusMinusButtons.plus.icon};
	}

`
InfoButton.displayName = 'InfoButton'

export const BackButton = styled(SignButton)`
`
BackButton.displayName = 'BackButton'
